import React from 'react';
import PropTypes from 'prop-types';
import RoundButton from './RoundButton';
import './PlaceholderSearch.css'


const PlaceholderSearch = ({ onLetterClick }) => {
    const alphabet = Array.from({length: 26}, (_, i) => String.fromCharCode(65 + i));

    const handleLetterClick = (letter) => {
        if (onLetterClick) {
            onLetterClick(letter);
        }
    };

    const placeholderData = [
        {title: "Abgetaucht - meine falschen Ferien", image: "pl-1.jpg"},
        {title: "Die Abenteuer des jungen Marco Polo", image: "pl-2.jpg"},
        {title: "Ansage", image: "pl-3.jpg"},
    ]

    return (
        <div>
            <div className="landing-title kika-search">
                    Sendungen A-Z
            </div>
            <div className='alphabet-container'>
                {alphabet.map((letter) => (
                    <RoundButton
                        key={letter}
                        letter={letter}
                        onClick={() => handleLetterClick(letter)}
                    />
                ))}
            </div>
            {
                placeholderData.map((item, index) => (
                <div className="card-landing">
                        <img src={item.image} alt={item.title} className="card-image-landing"/>
                        <div className="card-title-landing">{item.title}</div>
                </div>))
            }
        </div>
    );
};

PlaceholderSearch.propTypes = {
    onLetterClick: PropTypes.func,
};

export default PlaceholderSearch;